import { reactive } from 'vue'

const Simplestore = reactive({
    spinner: false
})
export default Simplestore;
